/*
 * Vairok · barra fija de compra de un toque (snippets/vk-sticky-atc.liquid)
 * - En móvil y en escritorio (Marc, 04/10: también en ordenador), con un diseño más ancho a partir de 768 px.
 * - Aparece cuando el botón principal queda por encima de la pantalla.
 * - Se esconde con el pie a la vista, con body.open-cc (cajón o menú) y con el banner de cookies de Shopify.
 * - Al pulsar hace click() en el botón principal, que envía el formulario con la cantidad de la ficha.
 * - Escucha vk:qty-change (vk-pdp.js): con 2 luces el precio pasa a «2 × 39,95 €» y se quita el tachado.
 */
(function () {
  'use strict';

  var MOBILE_QUERY = 'all'; // antes solo móvil; ahora todas las pantallas
  var COOKIE_BANNER_ID = 'shopify-pc__banner';

  function findMainButton(formId) {
    var button = null;
    if (formId) {
      var form = document.getElementById(formId);
      if (form) button = form.querySelector('.single-add-to-cart-button');
    }
    if (!button) button = document.querySelector('.thb-product-detail .single-add-to-cart-button');
    return button;
  }

  function isOverlayOpen() {
    var list = document.body.classList;
    for (var i = 0; i < list.length; i++) {
      if (list[i] === 'open-cc' || list[i].indexOf('open-cc') === 0) return true;
    }
    return false;
  }

  function isCookieBannerVisible() {
    var banner = document.getElementById(COOKIE_BANNER_ID);
    if (!banner || !banner.isConnected) return false;
    var style = window.getComputedStyle(banner);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = banner.getBoundingClientRect();
    return rect.height > 0 && rect.bottom > 0 && rect.top < window.innerHeight;
  }

  function init(root) {
    if (!root || root.getAttribute('data-vk-ready') === 'true') return;

    var formId = root.getAttribute('data-form-id');
    var main = findMainButton(formId);
    if (!main || !('IntersectionObserver' in window)) return;
    root.setAttribute('data-vk-ready', 'true');

    var button = root.querySelector('.vk-sticky__btn');
    var buttonText = root.querySelector('.vk-sticky__btn-text');
    var priceRow = root.querySelector('.vk-sticky__price');
    var nameRow = root.querySelector('.vk-sticky__name');
    var rating = root.querySelector('.vk-sticky__rating');
    var labelAdd = root.getAttribute('data-label-add') || (buttonText ? buttonText.textContent : '');
    var labelSold = root.getAttribute('data-label-sold') || labelAdd;
    var mq = window.matchMedia(MOBILE_QUERY);
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    // Fuera de cualquier contenedor con transform o z-index propio (no en el editor, para no romper la selección del bloque).
    if (!designMode && root.parentElement !== document.body) {
      document.body.appendChild(root);
    }

    var state = { passed: false, footer: false, overlay: isOverlayOpen(), cookie: false };
    var shown = null;

    function fit() {
      if (!mq.matches) return;
      root.classList.remove('is-tight');
      if (rating) rating.style.display = '';
      if (priceRow && priceRow.scrollWidth > priceRow.clientWidth + 1) root.classList.add('is-tight');
      if (rating && (rating.scrollWidth > rating.clientWidth + 1 || (nameRow && nameRow.scrollWidth > nameRow.clientWidth + 1))) {
        rating.style.display = 'none';
      }
    }

    function syncButton() {
      var soldOut = main.disabled || main.classList.contains('sold-out');
      button.disabled = soldOut;
      if (buttonText) buttonText.textContent = soldOut ? labelSold : labelAdd;
      button.classList.toggle('is-loading', main.classList.contains('loading'));
      button.setAttribute('aria-busy', main.classList.contains('loading') ? 'true' : 'false');
    }

    function update() {
      var show = mq.matches && state.passed && !state.footer && !state.overlay && !state.cookie;
      if (show === shown) return;
      shown = show;
      root.classList.toggle('is-visible', show);
      root.setAttribute('aria-hidden', show ? 'false' : 'true');
      button.setAttribute('tabindex', show ? '0' : '-1');
      document.body.classList.toggle('vk-sticky-on', show);
      if (!show && root.contains(document.activeElement)) document.activeElement.blur();
      if (show) fit();
    }

    // Botón principal: la barra sale cuando queda por encima de la pantalla
    var mainObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        state.passed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      });
      update();
    });
    mainObserver.observe(main);

    // Pie
    var footer = document.getElementById('footer') || document.querySelector('footer');
    if (footer) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          state.footer = entry.isIntersecting;
        });
        update();
      }).observe(footer);
    }

    // Cajón, menú y vista rápida (body.open-cc / open-cc--*)
    new MutationObserver(function () {
      var open = isOverlayOpen();
      if (open !== state.overlay) {
        state.overlay = open;
        update();
      }
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    // Banner de cookies de Shopify: entra y sale como hijo directo de body o cambia su estilo
    var bannerObserver = new MutationObserver(checkCookie);
    var watchedBanner = null;
    function checkCookie() {
      var banner = document.getElementById(COOKIE_BANNER_ID);
      if (banner && banner !== watchedBanner) {
        bannerObserver.disconnect();
        bannerObserver.observe(banner, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
        watchedBanner = banner;
      }
      var visible = isCookieBannerVisible();
      if (visible !== state.cookie) {
        state.cookie = visible;
        update();
      }
    }
    new MutationObserver(checkCookie).observe(document.body, { childList: true });
    checkCookie();

    // Estado del botón principal (agotado, cargando)
    new MutationObserver(syncButton).observe(main, { attributes: true, attributeFilter: ['class', 'disabled'] });
    syncButton();

    button.addEventListener('click', function () {
      var current = findMainButton(formId) || main;
      if (!current || current.disabled || current.classList.contains('loading')) return;
      current.click();
    });

    // Cantidad elegida en la ficha (1 o 2 luces): el precio de la barra la refleja
    var nowEl = root.querySelector('.vk-sticky__now');
    var wasEl = root.querySelector('.vk-sticky__was');
    var price1 = root.getAttribute('data-price-1');
    var price2 = root.getAttribute('data-price-2');
    function setQty(qty) {
      if (!nowEl || !price1 || !price2) return;
      var two = qty === 2;
      var text = two ? price2 : price1;
      if (nowEl.textContent !== text) nowEl.textContent = text;
      if (wasEl) wasEl.hidden = two;
      root.classList.toggle('is-qty-2', two);
      if (shown) fit();
    }
    document.addEventListener('vk:qty-change', function (event) {
      var q = event && event.detail ? parseInt(event.detail.quantity, 10) : 1;
      setQty(q === 2 ? 2 : 1);
    });
    var checkedQty = document.querySelector('input[name="vk-qty"]:checked');
    if (checkedQty) setQty(checkedQty.value === '2' ? 2 : 1);

    function onMediaChange() {
      update();
      fit();
    }
    if (mq.addEventListener) mq.addEventListener('change', onMediaChange);
    else if (mq.addListener) mq.addListener(onMediaChange);
    window.addEventListener('resize', function () {
      checkCookie();
      if (shown) fit();
    }, { passive: true });

    update();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-vk-sticky]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Editor de temas: la sección se vuelve a pintar al cambiar ajustes
  document.addEventListener('shopify:section:load', initAll);
})();
